import { useEffect } from 'react'
import { useLocation } from 'react-router-dom';

/*
When a user navigates be tween pages, React uses the last scroll position. 
This can cause a side-effect on the new page automagically, loading at the last scroll position. 
This component wraps all routes in the RootLayout to ensure the scroll position starts at 0.
*/

const ScrollToTop = ({ children }) => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
        document.body.style.zoom = 1;

    }, [location]);

    return (
        <>{children}</>
    )
}

export default ScrollToTop;